<template>
  <div>
    <jd-dialog class="ques-static-dialog" title="点赞人明细" :visible.sync="showDialog" width="918px" @close="onClose">
      <div class="ques-static-content">
        <el-form :model="formData" :rules="rules" ref="formRef" :inline="true">
          <el-form-item label="点赞人PIN" prop="pin">
            <el-input v-model="formData.pin" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="点赞人昵称" prop="memberNick">
            <el-input v-model="formData.memberNick" placeholder="请输入点赞人昵称" />
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" @click="search">查询</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>

        <jd-table v-loading="isLoading" :tableData="tableData" :pageInfo="{
          pageNum: formData.current,
          pageSize: formData.size,
          total: total,
        }" @handlePage="handlePage">
          <el-table-column label="点赞人昵称" prop="memberNick" />
          <el-table-column label="点赞人PIN" prop="pin" />
          <el-table-column label="点赞时间" prop="likeTime" />
        </jd-table>
      </div>
      <template #footer>
        <jd-button type="default" @click="onClose">取消</jd-button>
      </template>
    </jd-dialog>
  </div>
</template>

<script>
import { getPhotoContestRecordDetail } from "@/api/jhk/photoContestRecord.js";
/**
 * 点赞人明细
 */
export default {
  name: "onlineUserDetails",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    pkRecordId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      showDialog: false,
      isLoading: false,
      tableData: [],
      total: 0,
      formData: {
        size: 10,
        current: 1,
        pin: "",
        memberNick: "",
      },
    };
  },
  watch: {
    show(val) {
      this.showDialog = val;
      if (val) {
        this.getList();
      }
    },
  },
  methods: {
    search() {
      this.formData.size = 10;
      this.formData.current = 1;
      this.getList();
    },
    resetForm() {
      this.formData = {
        size: 10,
        current: 1,
        pin: "",
        memberNick: "",
      };
      this.getList();
    },
    async getList() {
      this.isLoading = true;
      const res = await getPhotoContestRecordDetail({
        pkRecordId: this.pkRecordId,
        ...this.formData,
      });
      this.isLoading = false;
      if (res.code == 1) {
        this.tableData = res.data.records;
        this.total = +res.data.total;
        // let list = res.data || [];
        // console.log("this.questionData>>", this.questionData);
      }
    },
    handlePage(pageInfo) {
      this.formData.size = pageInfo.pageSize;
      this.formData.current = pageInfo.pageNum;
      this.getList();
    },


    onClose() {
      this.$emit("update:show", false);
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog .el-dialog__body {
  padding: 20px 24px 15px !important;
}

/deep/ .el-progress-bar {
  padding-right: 65px;
  margin-right: -65px;

  .el-progress-bar__outer {
    height: 8px !important;
    background-color: rgba(0, 0, 0, 0.08) !important;

    .el-progress-bar__inner {
      background-color: #7b61ff !important;
    }

    .el-progress__text {
      font-size: 14px !important;
      color: #999999 !important;
    }
  }
}

.ques-static-dialog {
  .ques-static-content {
    min-height: 192px;
    max-height: 678px;
    height: auto;
    overflow-y: scroll;
    overflow-x: hidden;

    .box-card {
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #eeeeee;
      margin-bottom: 20px;

      .queTitle {
        padding: 16px 20px;
        background: #f8f9ff;
        font-size: 14px;
        color: #333333;
      }

      .ques-text-content {
        padding: 20px 20px;

        .queText {
          font-size: 14px;
          color: #333333;
          padding-bottom: 20px;
        }

        .queText:nth-last-child(1) {
          padding-bottom: 0px;
        }

        .img {
          width: 32px;
          height: 32px;
          border-radius: 2px 2px 2px 2px;
          display: block;
        }
      }

      .ques-text-content.ques-img-content {
        padding: 14px 20px;

        .queText {
          padding-bottom: 8px;

          &:nth-last-child(1) {
            padding-bottom: 0px;
          }
        }
      }

      .ques-text-content.ques-matrix-content {
        padding: 20px;
      }
    }
  }
}

.progress {
  display: flex;
  width: 50%;
  align-items: center;
  justify-content: space-evenly;
}

.progre .progress-num {
  width: 25%;
  text-align: right;
  font-size: 14px;
  color: #999999;
  margin-right: 8px;
}
</style>
<style></style>
